<mat-toolbar color="primary">

    <button mat-icon-button (click)="touchToggle()">
        <mat-icon>menu</mat-icon>
    </button>
    <!-- <span>
        {{ appNameMsg }}
    </span> -->

    <!-- nombre de la app -->
    <!-- <span>{{ appNameMsg }}</span> -->
    <button mat-flat-button routerLink="inicio" color="primary" *ngIf="mostrarDashboardBtn">
        <mat-icon>home</mat-icon>
        Inicio
    </button>
    <button class="btnNoti" mat-flat-button [matMenuTriggerFor]="menu2" color="primary">
        <mat-icon [matBadge]="variable.cantidad" matBadgeColor="accent">notifications</mat-icon>
    </button>

    <!-- espacio intermedio -->
    <span class="toolbar-space"></span>

    <span>{{ moduleName }}</span>

    <!-- espacio intermedio -->
    <span class="toolbar-space"></span>

    <!-- menu superior derecho -->
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #menu="matMenu">

        <button mat-menu-item routerLink="../modulos">
            <mat-icon>view_module</mat-icon>
            Seleccionar Modulo
        </button>

        <button mat-menu-item (click)="cambiarPassword()">
            <mat-icon>vpn_key</mat-icon>
            Cambiar Contraseña
        </button>

        <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            {{ logoutMsg }}
        </button>

    </mat-menu>

</mat-toolbar>


    <mat-menu class="ventanaNotificacion" #menu2="matMenu" style="box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);" (closed)="onMenuClosed()" >
        <div class="title" >Notificaciones</div>
            <cdk-virtual-scroll-viewport #scrollableElement appendOnly itemSize="5" class="example-viewport" (scrolledIndexChange)="onScroll($event)">
                <div  *cdkVirtualFor="let noti of notificaciones" class="contenedor" (click)="itemNotificacion(noti)" >
                    <hr>
                            <td class="icono">
                                <div class="icono">
                                    <mat-icon class="color_blue" style="border-style: solid; border-radius: 50%; color: #00684b; padding: 7px;" *ngIf="noti.isNew === true">local_post_office</mat-icon>
                                    <mat-icon class="color_blue" style="border-style: solid; border-radius: 50%; color: #00684b; padding: 7px;" *ngIf="noti.isNew === false">drafts</mat-icon>
                                </div>
                            </td>
                            <td>
                                <div class="fecha" >{{noti.fechaEntrega | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                                <div class="texto" style="font-family: sans-serif;">{{noti.asunto}}</div>
                                <div class="texto" style="font-family: sans-serif;">{{noti.mensaje}}</div>
                            </td>
                            <hr>

                </div>
                <div class="margen icono" style="font-weight: bold; font-size: 16px;" *ngIf="finalNotificacion === true">
                    No se encontraron más notificaciones
                </div>
                <div class="margen icono" style="font-weight: bold; font-size: 16px;" *ngIf="sinNotificacion === true">
                    No cuenta con ninguna notificacion nueva
                </div>
            </cdk-virtual-scroll-viewport>
    </mat-menu>
